/** Estilos mínimos para imprimir ayuda contextual. */
const PRINT_STYLES = `
  body {
    font-family: system-ui, sans-serif;
    font-size: 11pt;
    line-height: 1.45;
    color: #1c2b33;
    margin: 1.5cm;
    text-align: left;
  }
  h1 {
    font-size: 16pt;
    margin: 0 0 8px;
    text-align: left;
  }
  .help-detail__title {
    text-align: center;
    font-size: 10pt;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    margin: 18px 0 8px;
  }
  p, li, dd { text-align: left; }
  ul { padding-left: 1.25em; }
  dl { margin: 0; }
  dt { font-weight: 600; margin-top: 8px; }
  dd { margin: 0 0 8px 0; }
  .screen-help-panel__nav {
    color: #5a6474;
    font-size: 10pt;
    margin: 0 0 8px;
  }
  .screen-help-panel__summary {
    margin: 0 0 12px;
  }
`

const escapeHtml = (value) => String(value).replace(/</g, '&lt;')

/**
 * Abre el diálogo de impresión con el contenido de ayuda.
 * Usa un iframe oculto para evitar bloqueadores de ventanas emergentes.
 * @param {{ title: string, contentHtml: string }} params
 * @returns {boolean}
 */
export const printContextualHelp = ({ title, contentHtml }) => {
  try {
    const iframe = document.createElement('iframe')
    iframe.setAttribute('title', 'Imprimir ayuda')
    iframe.setAttribute('aria-hidden', 'true')
    Object.assign(iframe.style, {
      position: 'fixed',
      right: '0',
      bottom: '0',
      width: '0',
      height: '0',
      border: 'none',
      opacity: '0',
      pointerEvents: 'none',
    })
    document.body.appendChild(iframe)

    const win = iframe.contentWindow
    const doc = win?.document
    if (!doc) {
      iframe.remove()
      return false
    }

    const safeTitle = escapeHtml(title)
    doc.open()
    doc.write(`<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="utf-8" />
  <title>${safeTitle}</title>
  <style>${PRINT_STYLES}</style>
</head>
<body>
  <h1>${safeTitle}</h1>
  ${contentHtml}
</body>
</html>`)
    doc.close()

    const cleanup = () => {
      iframe.remove()
    }

    win.addEventListener('afterprint', cleanup, { once: true })
    setTimeout(cleanup, 60_000)

    win.focus()
    win.print()
    return true
  } catch {
    return false
  }
}
